import {SocialMediaWizardStep} from '@Components/social-media-wizard/social-media-wizard.types';

export enum SocialMediaWizardOnboardingTypes {
  DESIGN_SELECTOR = 'DESIGN_SELECTOR',
  SELECT_ACCOUNTS = 'SELECT_ACCOUNTS',
  CONNECT_ACCOUNTS = 'CONNECT_ACCOUNTS',
  ADD_DETAILS = 'ADD_DETAILS',
  NONE = 'NONE',
}

export interface OnboardingPopupPosition {
  top: string;
  left: string;
}

export const ONBOARDING_OVERLAY_Z_INDEX = 2000;

export const ONBOARDING_POPUP_ANCHOR_GAP = 8;

export const ONBOARDING_POPUP_VIEWPORT_MARGIN = 20;

export const ADD_DETAILS_SCHEDULE_CONTROLS_RIGHT_NUDGE = 50;
export const ADD_DETAILS_PUBLISH_OPTIONS_RIGHT_NUDGE = 65;

export const WizardStepIndex: Record<SocialMediaWizardStep, number> = {
  [SocialMediaWizardStep.SELECT_DESIGN]: 0,
  [SocialMediaWizardStep.SELECT_ACCOUNTS]: 1,
  [SocialMediaWizardStep.ACCOUNT_CONNECTION]: 3,
  [SocialMediaWizardStep.EDIT_TEMPLATE]: 4,
  [SocialMediaWizardStep.ADD_DETAILS]: 4,
  [SocialMediaWizardStep.PUBLISH]: 5,
};

export const getOnboardingType = (wizardStep: SocialMediaWizardStep): SocialMediaWizardOnboardingTypes => {
  switch (wizardStep) {
    case SocialMediaWizardStep.SELECT_DESIGN:
      return SocialMediaWizardOnboardingTypes.DESIGN_SELECTOR;

    case SocialMediaWizardStep.SELECT_ACCOUNTS:
      return SocialMediaWizardOnboardingTypes.SELECT_ACCOUNTS;

    case SocialMediaWizardStep.ADD_DETAILS:
      return SocialMediaWizardOnboardingTypes.ADD_DETAILS;

    case SocialMediaWizardStep.EDIT_TEMPLATE:
      return SocialMediaWizardOnboardingTypes.NONE;

    case SocialMediaWizardStep.PUBLISH:
      return SocialMediaWizardOnboardingTypes.NONE;

    default:
      return SocialMediaWizardOnboardingTypes.CONNECT_ACCOUNTS;
  }
};

export const getPopupLoadingFunctionNameByOnboardingType = (onboardingType: SocialMediaWizardOnboardingTypes, isResizable?: boolean): string => {
  switch (onboardingType) {
    case SocialMediaWizardOnboardingTypes.DESIGN_SELECTOR:
      return 'loadDesignSelectorOnboardingPopups';

    case SocialMediaWizardOnboardingTypes.ADD_DETAILS:
      if (isResizable) {
        return 'loadAddDetailsResizeOnboardingPopups';
      }
      return 'loadAddDetailsNonResizeOnboardingPopups';

    case SocialMediaWizardOnboardingTypes.NONE:
      return '';

    case SocialMediaWizardOnboardingTypes.CONNECT_ACCOUNTS:
      return '';

    case SocialMediaWizardOnboardingTypes.SELECT_ACCOUNTS:
      return 'loadSelectAccountsOnboardingPopups';
  }
};
